import swal from 'sweetalert'
export default {
  name: 'version',
  components: {},
  props: [],
  data () {
    return {
      documents: [],
      loading: false,
      document: {},
      errors: [],
      new_file: null,
      accept: '.xlsx,.xls, .doc, .docx,.ppt, .pptx,.txt,.pdf',
    }
  },
  computed: {
   
  },
  mounted () {

  },
  methods: {
    show (document) {
      this.$refs.file.reset()
      this.document = document
      this.documents = []
      this.$refs.versionModal.show()
      this.loading = true
      Promise.all([
        this.$store.dispatch('Document/getVersionDocument', {document})
      ]).then(res => {
        this.documents = res[0]
        // document.version = "Hiện tại"
        this.documents.push(document)
        this.loading = false
      }).catch(errors => {
        this.loading = false
      })
    },
    destroy (version) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
          
            this.$store.dispatch('Document/destroyVersionDocument', {
              document: this.document, version
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              var index = 0
              this.documents.forEach((doc, i) => {
                if(doc.id === res.id) {
                  index = i
                  return
                }
              })
              this.documents.splice(index, 1)
              
            }).catch(errors => {
              
            })
          }
        })
    },
    icon (document) {
      switch (document.file.split('.')[document.file.split('.').length -1 ]) {
        case 'doc': case 'docx' : 
          return 'fa fa-file-word-o text-success'
          break
        case 'pdf': case 'pdfx' : 
          return 'fa fa-file-pdf-o text-primary'
          break
        case 'xls': case 'xlsx' : 
          return 'fa fa-file-excel-o text-primary'
          break
        default:
          return 'fa fa-file text-primary'
          break
      }
    },

    _handleClick (e) {
      // e.target.value = null
    },
    _handleChange (e) {
      this.new_file = this.$refs.file.files[0]
      // this.onChange(e.target.files[0])
    },
    upload () {
      const data = new FormData()
      data.append('file_path', this.new_file)
    
      this.$store.dispatch('Document/createVersionDocument',{version: data, document: this.document}).then(res=>{
        
        this.errors = []
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.documents.unshift(res)
      this.$refs.file.reset()
      this.new_file = null
    }).catch( errors => {
        if(errors.status === 422) {
          this.errors = errors.data.error
        }
        
      })
    },

    view (document) {
      return 'https://docs.google.com/viewerng/viewer?url=' + document.file
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document/version/version.js